import React from "react";
import propTypes from "prop-types";
import classNames from "classnames";
import { DefaultPageContainer as PageContainer } from "@layout";
import { HeroBlog, ContentBuilder } from "@organisms";
import { AnchoredTitle, CbCopy } from "@molecules";
import { Container, Button, Text, Icon } from "@atoms";
import moment from "moment";

const PrivacyPolicyPage = ({ data }) => {
  const {
    title,
    excerpt,
    effectiveDate,
    updateDate,
    meta,
    content,
    sections,
  } = data;

  const formattedDate = date => {
    return moment(date).format("MMMM D, YYYY");
  };

  return (
    <PageContainer meta={meta}>
      <Container variant="lg" className="mt-10">
        <div className="relative">
          <Text variant="h3" className="mt-6 mb-10">{title}</Text>
          <ul className="flex space-x-4 my-3">
            <li>
              <Text variant="sm" className="italic inline">
                <span className="text-teal mr-1">Effective:</span> {formattedDate(effectiveDate)}
              </Text>
            </li>
            <li>
              <Text variant="sm" className="italic inline">
                <span className="text-teal mr-1">Last updated:</span> {formattedDate(updateDate)}
              </Text>
            </li>
          </ul>

          <div className="my-8 max-w-3xl">
            <Text variant="body" className="inline-block">{excerpt}</Text>
          </div>

          <Icon
            name="fingerprintsSimple"
            className="absolute w-[800px] lg:w-[1000px] transform -z-10 opacity-30 pointer-events-none top-[-19rem] -left-96 lg:left-[-37rem] rotate-0 scale-y-[-1] text-teal"
          />
        </div>

        <ul className="grid grid-flow-cols grid-rows-10 grid-cols-1 md:grid-cols-2 grid-row-auto max-w-3xl gap-4 md:gap-6">
          <div className="grid gap-4">
            {sections?.left?.map((section, i) => {
              return <AnchoredTitle {...section} key={`section left ${i}`}/>;
            })}
          </div>
          <div className="grid gap-4">
            {sections?.right?.map((section, i) => {
              return <AnchoredTitle {...section} key={`section right ${i}`}/>;
            })}
          </div>
        </ul>
      </Container>

      <Container variant="lg">
        <div className="my-8 max-w-3xl">
          {content?.map((copy, i) => {
            return (
              <div id={copy?.anchor} className="my-6">
                <CbCopy {...copy} key={`copy ${i}`} />
              </div>
            );
          })}
        </div>
      </Container>
      <div className="h-[60rem] w-full absolute bg-soft-red-blue-gradient bottom-0 -z-10 opacity-20" />
    </PageContainer>
  );
};

PrivacyPolicyPage.defaultProps = {};

PrivacyPolicyPage.propTypes = {};

export default PrivacyPolicyPage;
